module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/jVIstVZxmnsHBvx2qUyU2-d8ff44da2f93bebe3c7b433e2ef190b2.jpg";